import { initialState } from '../initialState'
import { sessionActions } from '../actions'
import { createReducer } from './utilities'

const { session } = initialState

const setJwtToken = (state, { token }) => {
  return {
    ...state,
    JwtToken: token
  }
}

const destroyJwtToken = state => {
  return {
    ...state,
    JwtToken: null
  }
}

const reset = state => {
  return {
    ...state,
    JwtToken: null
  }
}

const user = (state, { user }) => {
  return {
    ...state,
    user
  }
}

export const sessionReducer = createReducer(session, {
  [sessionActions.LOGIN]: setJwtToken,
  [sessionActions.LOGOUT]: destroyJwtToken,
  [sessionActions.ME]: user,
  [sessionActions.RESET]: reset
})
